import { useAuth } from 'services/AuthProvider/AuthProvider'
import { getAuthRequestConfig } from 'services/LoginUtills'
import { analytics, EVENT_NAMES } from 'services/Analytics/Analytics'
import { mixtilesAxios } from 'utils/ApiUtils'
import { logger } from 'services/logger'

type SignOutSource = 'Menu' | 'Refresher Kit Switch Account'

export default function useSignOut() {
  const { user, getIdToken, logout } = useAuth()

  const signOut = async ({
    returnToUrl,
    source,
  }: {
    returnToUrl: string
    source: SignOutSource
  }) => {
    try {
      const token = await getIdToken()
      const config = getAuthRequestConfig(token)
      const response = await mixtilesAxios.get('v1/auth/loginSuccess', config)
      const { analyticsInfo } = response.data
      const { previousOrdersCount } = analyticsInfo
      analytics.track(EVENT_NAMES.SIGN_OUT_TAPPED, {
        Email: user?.email,
        'Number of Previous Orders': previousOrdersCount,
        Source: source,
      })
    } catch (e) {
      logger.error('Failed to get analytics info', e)
    }

    logout(returnToUrl)
  }

  return { signOut }
}
